var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarrierSystemIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.7,
    width: 20.6,
    height: 13.6,
    rx: 2.3,
    stroke: "black",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78018 10.9978V3.90781H4.85018C4.63018 4.74781 3.90018 5.17781 2.68018 5.17781V6.10781H4.38018V10.9978H5.78018Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9068 6.00781C12.9068 4.63781 11.9668 3.75781 10.4768 3.75781C9.00682 3.75781 8.14682 4.62781 8.14682 6.12781C8.14682 6.18781 8.14682 6.26781 8.15682 6.37781H9.49682V6.14781C9.49682 5.35781 9.86682 4.89781 10.5068 4.89781C11.1268 4.89781 11.5068 5.32781 11.5068 6.03781C11.5068 6.81781 11.2568 7.12781 9.69682 8.23781C8.49682 9.05781 8.12682 9.68781 8.05682 10.9978H12.8768V9.74781H9.87682C10.0568 9.36781 10.2768 9.16781 11.3168 8.40781C12.5468 7.50781 12.9068 6.96781 12.9068 6.00781Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6735 8.81781C18.6735 7.98781 18.3135 7.51781 17.5135 7.12781C18.1735 6.71781 18.4435 6.33781 18.4435 5.68781C18.4435 4.50781 17.5635 3.75781 16.1935 3.75781C14.8235 3.75781 13.8935 4.47781 13.8935 6.01781V6.13781H15.1935C15.1935 5.25781 15.4735 4.88781 16.1635 4.88781C16.7235 4.88781 17.0435 5.22781 17.0435 5.81781C17.0435 6.52781 16.6335 6.81781 15.8035 6.81781H15.6835V7.75781C16.7335 7.75781 17.2735 8.05781 17.2735 8.81781C17.2735 9.43781 16.8335 9.88781 16.2235 9.88781C15.5635 9.88781 15.1635 9.50781 15.1635 8.77781H13.8035C13.8035 10.1978 14.7435 11.0878 16.1935 11.0878C17.7035 11.0878 18.6735 10.1978 18.6735 8.81781Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrierSystemIcon);
export default __webpack_public_path__ + "static/media/barrier-system-icon.7549b5f4.svg";
export { ForwardRef as ReactComponent };